import { useEffect, useRef } from 'react';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';

export const createIssueAri = (cloudId: string, issueId: string) =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: issueId,
	});

export const useMemoizedIssueAris = (issueAris: string[]): string[] => {
	const previousArrayRef = useRef<string[]>();
	const sortedArray = [...issueAris].sort();

	useEffect(() => {
		const previousArray = previousArrayRef.current;
		if (previousArray == null || previousArray.length !== sortedArray.length) {
			previousArrayRef.current = sortedArray;
		} else {
			const arraysAreEqual = previousArray.every((value, index) => value === sortedArray[index]);
			if (!arraysAreEqual) {
				previousArrayRef.current = sortedArray;
			}
		}
	}, [sortedArray]);

	return previousArrayRef.current == null ? sortedArray : previousArrayRef.current;
};
